import { basketReducer } from '../../basket/reducers/BasketReducer';
import basketSaga from '../../basket/sagas/BasketSagas';
import { compareReducer } from '../../compare/reducers/CompareReducer';
import compareSaga from '../../compare/sagas/CompareSagas';
import deliveryPromiseSaga from '../../deliveryPromise/sagas/DeliveryPromiseSaga';
const loadEssentialsModule = () => ({
    id: 'Essentials',
    reducerMap: {
        basket: basketReducer,
        compare: compareReducer,
    },
    sagas: [basketSaga, compareSaga, deliveryPromiseSaga],
});
export default loadEssentialsModule;
